import { useState, useEffect } from "react"

/**
 * Hook to manage all canvas-related UI state
 * Includes: selection, dimensions, guides, text editing, and dragging state
 * @returns {Object} Canvas state and setter functions
 */
export function useCanvasState() {
  // Selection state
  const [selectedElementId, setSelectedElementId] = useState(null)
  const [selectedElementIds, setSelectedElementIds] = useState([])

  // Canvas dimensions and display - load from localStorage
  const [canvasDimensions, setCanvasDimensions] = useState(() => {
    const saved = localStorage.getItem("canvasDimensions")
    return saved
      ? JSON.parse(saved)
      : {
          width: 750,
          height: 1050, // Default to portrait mode
        }
  })
  const [scale] = useState(1)
  const [showGuides, setShowGuides] = useState(true)

  // Save canvas dimensions to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("canvasDimensions", JSON.stringify(canvasDimensions))
  }, [canvasDimensions])

  // Selection rect (for drag-select)
  const [selectionRect, setSelectionRect] = useState(null)
  const [isSelecting, setIsSelecting] = useState(false)

  // Layers panel drag state
  const [draggedOverIndex, setDraggedOverIndex] = useState(null)
  const [dropPosition, setDropPosition] = useState(null)

  // Text editing state (inline editor)
  const [editingTextId, setEditingTextId] = useState(null)
  const [editingTextValue, setEditingTextValue] = useState("")
  const [inputPosition, setInputPosition] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    fontSize: 20,
  })

  // Layers panel text editing state
  const [editingLayerTextId, setEditingLayerTextId] = useState(null)
  const [editingLayerTextValue, setEditingLayerTextValue] = useState("")

  // Text tool defaults
  const [textFontFamily, setTextFontFamily] = useState("Arial")
  const [textFontSize, setTextFontSize] = useState(20)

  // Snap guide highlighting state
  const [snappedAxes, setSnappedAxes] = useState({ x: false, y: false })

  return {
    // Selection
    selectedElementId,
    setSelectedElementId,
    selectedElementIds,
    setSelectedElementIds,

    // Canvas dimensions and display
    canvasDimensions,
    setCanvasDimensions,
    scale,
    showGuides,
    setShowGuides,

    // Selection rect
    selectionRect,
    setSelectionRect,
    isSelecting,
    setIsSelecting,

    // Layers panel drag state
    draggedOverIndex,
    setDraggedOverIndex,
    dropPosition,
    setDropPosition,

    // Text editing (inline)
    editingTextId,
    setEditingTextId,
    editingTextValue,
    setEditingTextValue,
    inputPosition,
    setInputPosition,

    // Text editing (layers panel)
    editingLayerTextId,
    setEditingLayerTextId,
    editingLayerTextValue,
    setEditingLayerTextValue,

    // Text tool defaults
    textFontFamily,
    setTextFontFamily,
    textFontSize,
    setTextFontSize,

    // Snap guide highlighting
    snappedAxes,
    setSnappedAxes,
  }
}
